export const compMembershipPeriod = 3
